import React, {  useContext } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import Loading from "../core/Loading";
import useMediaQuery from "../../hooks/useMediaQuery";
//import ModalContext from "../../context/modal/modalContext";
import PortalContext from "../../context/portal/portalContext";
//import ModalMui from "../core/ModalMui";
//import TermsOfUseMui from "../core/TermsOfUseMui";
import ContactCard from "./ContactCard"
import "./MyAccount.css";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    //marginBottom: "70px",
  },
  rootResponsive: {
    flexGrow: 1,
    marginBottom: "70px",
  },
  paper: {
    textAlign: "left",
  },
  typography: {
    padding: theme.spacing(2),
    fontSize: "22px",
  },
  containerKey: {
    padding: theme.spacing(2),
  },
  pValue: {
    margin: 0,
    padding: "5px",
    fontSize: "14px",
  },
}));

const MyAccount = (props) => {
  const portalContext = useContext(PortalContext);
  const { data, billData, terminals, loading } = portalContext;
  //const modalContext = useContext(ModalContext);
  //const { modalShow, showModal, closeModal } = modalContext;

  //const [modalContent, setModalContent] = useState(null);
  //const [modalTitle, setModalTitle] = useState("");

  const classes = useStyles();
  const isMobile = useMediaQuery("max-width", 600);

  const showTermsOfUseModal = () => {
    window.open('/app/terms-of-use', '_blank');
    // window.location.href = "/app/terms-of-use";
    // setModalTitle("Términos de Uso");
    // setModalContent(
    //   <TermsOfUseMui closeModal={closeModal}></TermsOfUseMui>     
    //   );
    // showModal();
  };
  const theData = props.isBill ? billData : data
  if (!theData) {
    return <Loading />;
  }

  return (
    <div className={!isMobile ? classes.root : classes.rootResponsive}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Paper elevation={0} className={classes.paper}>
            <Typography className={classes.typography}>
              Datos del contribuyente
            </Typography>
          </Paper>
        </Grid>
        {theData.taxPayerInfo&&
        <Grid item xs={6}>
          <a className="status-button" href={`http://3.140.43.11/pago-web-vale/api3.php?rut=${theData.taxPayerInfo.rut}`}>
          {/* <a class="status-button" href={`https://valeelectronico.cl/pago-web-vale/api3.php?rut=${data.taxPayerInfo.rut}`}> */}
            Ver estado de cuenta
          </a>
        </Grid>
        }
        {!isMobile ? (
          <DesktopMyAccount
            classes={classes}
            data={theData}
            terminals={terminals}
          />
        ) : (
          <ResponsiveMyAccount
            classes={classes}
            data={theData}
            terminals={terminals}
          />
        )}

        <Grid item xs={12}>
          <Paper elevation={0} className={classes.paper}>
            <a href="#" onClick={showTermsOfUseModal} className="terms-of-use">Términos de uso</a>

          </Paper>
        </Grid>
        <Grid item xs={6} >
          <Paper elevation={0} className={classes.paper}>
            <ContactCard title={"Ventas:"} mail={"ventas@taschile.cl"} phone1={"(+56) 2 2379 8218 Opc. 1"}></ContactCard>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper elevation={0} className={classes.paper}>
            <ContactCard title={"Soporte:"} mail={"soporte@taschile.cl"} phone1={"(+56) 2 2379 8218 Opc. 2"}></ContactCard>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper elevation={0} className={classes.paper}>
            <ContactCard title={"Cobranza:"} mail={"pagos@taschile.cl"} phone1={"(+56) 2 2379 8218 Opc. 3"}></ContactCard>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper elevation={0} className={classes.paper}>
            <ContactCard title={"Logística:"} mail={"logistica@taschile.cl"}></ContactCard>
          </Paper>
        </Grid>
      </Grid>

    </div>
  );
};

const DesktopMyAccount = ({ classes, data, terminals }) => {
  return (
    <>
      <Grid item xs={6}>
        <Paper elevation={0} className={classes.paper}>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Nombre</p>
            <p className={classes.pValue}>
              <strong>{data.taxPayerInfo.name}</strong>
            </p>
          </div>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Apellido</p>
            <p className={classes.pValue}>
              <strong>{data.taxPayerInfo.lastname}</strong>
            </p>
          </div>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>RUT</p>
            <p className={classes.pValue}>
              <strong>{data.taxPayerInfo.rut}</strong>
            </p>
          </div>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Razón Social</p>
            <p className={classes.pValue}>
              <strong>{data.taxPayerInfo.companyName}</strong>
            </p>
          </div>
          <div
            className={classes.containerKey}
            style={{ overflowY: "scroll", width: "200px", height: "200px" }}
          >
            <p className={classes.pValue}>Terminales asociadas</p>
            {terminals.length === 0
              ? "No hay terminales asociadas"
              : terminals.map((terminal, index) => (
                <p className={classes.pValue} key={index}>
                  <strong>{terminal}</strong>
                </p>
              ))}
          </div>
        </Paper>
      </Grid>
      <Grid item xs={6}>
        <Paper elevation={0} className={classes.paper}>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Tipo de Contrato</p>
            <p className={classes.pValue}>
              <strong>{data.taxPayerInfo.contractType}</strong>
            </p>
          </div>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Cupón ingresado para el próxima facturación</p>
            <p className={classes.pValue}>
              <strong>{data.taxPayerInfo.voucherInfo}</strong>
            </p>
          </div>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Estado del Servicio</p>
            <p className={classes.pValue}>
              <strong>{data.taxPayerInfo.siiServiceStatus}</strong>
            </p>
          </div>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Fecha de Alta</p>
            <p className={classes.pValue}>
              <strong>
                {data.taxPayerInfo.activationDate
                  ? moment(data.taxPayerInfo.activationDate).format(
                    "DD-MM-YYYY"
                  )
                  : " No hay dato"}
              </strong>
            </p>
          </div>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Fecha declaración IVA</p>
            <p className={classes.pValue}>
              <strong>
                {data.taxPayerInfo.declarationVATDate
                  ? moment(data.taxPayerInfo.declarationVATDate).format(
                    "DD-MM-YYYY"
                  )
                  : "No hay dato"}
              </strong>
            </p>
          </div>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Última fecha de pago del servicio</p>
            <p className={classes.pValue}>
              <strong>
                {data.lastBillPayedToTAS}
              </strong>
            </p>
          </div>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Fecha de baja</p>
            <p className={classes.pValue}>
              <strong>
                {data.taxPayerInfo.deactivationDate
                  ? moment(data.taxPayerInfo.deactivationDate).format(
                    "DD-MM-YYYY"
                  )
                  : "N/A"}
              </strong>
            </p>
          </div>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Folios disponibles</p>
            <p className={classes.pValue}>
              <strong>
                Folios afectos: <span>{data.availableDTEs.available39DTE}</span>
              </strong>
            </p>
            <p className={classes.pValue}>
              <strong>
                Folios exentos: <span>{data.availableDTEs.available41DTE}</span>
              </strong>
            </p>
          </div>
          <div className={classes.containerKey}>
            <p className={classes.pValue}>Certificado de firma</p>
            <p className={classes.pValue}>
              <strong>
                Fecha de activación: <span>{data.taxPayerInfo.certEffectiveDate}</span>
              </strong>
            </p>
            <p className={classes.pValue}>


              <strong className={data.taxPayerInfo.hasToShowRedExpirationDate ? "red-span" : "green-span"}>
                Fecha de vencimiento: <span>{data.taxPayerInfo.certExpirationDate}</span>
              </strong>


            </p>
          </div>


        </Paper>
      </Grid>
    </>
  );
};

const ResponsiveMyAccount = ({ classes, data, terminals }) => {
  return (
    <Grid item xs={12}>
      <Paper elevation={0} className={classes.paper}>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Nombre</p>
          <p className={classes.pValue}>
            <strong>{data.taxPayerInfo.name}</strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Apellido</p>
          <p className={classes.pValue}>
            <strong>{data.taxPayerInfo.lastname}</strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>RUT</p>
          <p className={classes.pValue}>
            <strong>{data.taxPayerInfo.rut}</strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Razón Social</p>
          <p className={classes.pValue}>
            <strong>{data.taxPayerInfo.companyName}</strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Terminales asociadas</p>
          {terminals.length === 0
            ? "No hay dato"
            : terminals.map((terminal, index) => (
              <p className={classes.pValue} key={index}>
                <strong>{terminal}</strong>
              </p>
            ))}
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Tipo de Contrato</p>
          <p className={classes.pValue}>
            <strong>{data.taxPayerInfo.contractType}</strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Cupón ingresado para el próxima facturación</p>
          <p className={classes.pValue}>
            <strong>{data.taxPayerInfo.voucherInfo}</strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Estado de Servicio</p>
          <p className={classes.pValue}>
            <strong>{data.taxPayerInfo.siiServiceStatus}</strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Fecha de Alta</p>
          <p className={classes.pValue}>
            <strong>
              {data.taxPayerInfo.activationDate
                ? moment(data.taxPayerInfo.activationDate).format("DD-MM-YYYY")
                : "No hay dato"}
            </strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Fecha declaración IVA</p>
          <p className={classes.pValue}>
            <strong>
              {data.taxPayerInfo.declarationVATDate
                ? moment(data.taxPayerInfo.declarationVATDate).format(
                  "DD-MM-YYYY"
                )
                : "No hay dato"}
            </strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Última fecha de pago del servicio</p>
          <p className={classes.pValue}>
            <strong>
              {data.lastBillPayedToTAS}
            </strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Fecha de baja</p>
          <p className={classes.pValue}>
            <strong>
              {data.taxPayerInfo.deactivationDate
                ? moment(data.taxPayerInfo.deactivationDate).format(
                  "DD-MM-YYYY"
                )
                : "N/A"}
            </strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Folios disponibles</p>
          <p className={classes.pValue}>
            <strong>
              Folios afectos: <span>{data.availableDTEs.available39DTE}</span>
            </strong>
          </p>
          <p className={classes.pValue}>
            <strong>
              Folios exentos: <span>{data.availableDTEs.available41DTE}</span>
            </strong>
          </p>
        </div>
        <div className={classes.containerKey}>
          <p className={classes.pValue}>Certificado de firma</p>
          <p className={classes.pValue}>
            <strong>
              Fecha de activación: <span>{data.taxPayerInfo.certEffectiveDate}</span>
            </strong>
          </p>
          <p className={classes.pValue}>
            <strong>
              Fecha de vencimiento: <span>{data.taxPayerInfo.certExpirationDate}</span>
            </strong>
          </p>
        </div>
      </Paper>
    </Grid>
  );
};

export default MyAccount;
